module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 49
// module chunks = 22